<ag-grid-angular class="data-grid " [gridOptions]="gridOptions" [rowData]="data" [attr.aria-label]="widgetTitle"></ag-grid-angular>
